import { defaultWarehouse, resolveWarehouse, subscribeWarehouse } from 'rc-warehouse';

if (!customElements.get('rc-new-arrivals')) {
  customElements.define('rc-new-arrivals', class extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.warehouseKey = undefined;
      this.target = this.querySelector('[data-arrivals-products]');
      this.link = this.querySelector('[data-arrivals-link]');
      this.unsubscribe = subscribeWarehouse(warehouse => this.loadProducts(warehouse));
      resolveWarehouse().then(warehouse => {
        if (this.connected) this.loadProducts(warehouse);
      }).catch(() => {
        if (this.connected) this.loadProducts(defaultWarehouse);
      });
    }

    disconnectedCallback() {
      this.connected = false;
      this.request?.abort();
      this.unsubscribe?.();
    }

    async loadProducts(warehouse) {
      warehouse = warehouse || defaultWarehouse;
      if (this.warehouseKey === warehouse.id) return;
      this.warehouseKey = warehouse.id;
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      const timer = setTimeout(() => request.abort(), 10000);
      // Keep server-rendered coffees (or the last successful result) visible.
      // Only replace the cards and link together once a nonempty result arrives.
      this.target.setAttribute('aria-busy', 'true');
      const candidates = warehouse.id === defaultWarehouse.id
        ? [defaultWarehouse, null] : [warehouse, defaultWarehouse, null];

      try {
        for (const candidate of candidates) {
          if (request.signal.aborted || this.request !== request || !this.connected) return;
          const url = new URL(this.dataset.url, window.location.href);
          if (candidate) url.searchParams.set('filter.p.m.custom.warehouse', candidate.filter);
          else url.searchParams.delete('filter.p.m.custom.warehouse');
          url.searchParams.delete('view');
          const collectionUrl = url.href;
          url.searchParams.set('view', 'home-new-arrivals');
          try {
            const response = await fetch(url.href, { credentials: 'same-origin', signal: request.signal });
            if (!response.ok) continue;
            const page = new DOMParser().parseFromString(await response.text(), 'text/html');
            const source = page.querySelector('[data-arrivals-products]');
            const normalized = value => (value || '').trim().toLowerCase();
            if (!source || normalized(source.dataset.arrivalsSaleType) !== 'buy online'
                || normalized(source.dataset.arrivalsPosition) !== 'spot'
                || normalized(source.dataset.arrivalsWarehouse) !== (candidate?.id || '')) continue;
            const count = Math.max(1, Math.min(8, Number(this.dataset.count) || 4));
            const products = Array.from(source.children).filter(item => item.hasAttribute('data-product-item')).slice(0, count);
            if (this.request !== request || !this.connected || request.signal.aborted) return;
            if (!products.length) continue;
            this.target.replaceChildren(...products);
            this.target.hidden = false;
            this.link.href = collectionUrl;
            return;
          } catch (_) {
            // Try Oakland, then any eligible Spot coffees. If all requests fail,
            // the original coffees remain usable, including with blocked JS.
          }
        }
      } finally {
        clearTimeout(timer);
        if (this.request === request && this.connected) this.target.setAttribute('aria-busy', 'false');
      }
    }
  });
}
